import { render, staticRenderFns } from "./ChartWorkBenchmarking.vue?vue&type=template&id=7630a557&scoped=true"
import script from "./ChartWorkBenchmarking.vue?vue&type=script&lang=ts"
export * from "./ChartWorkBenchmarking.vue?vue&type=script&lang=ts"
import style0 from "./ChartWorkBenchmarking.vue?vue&type=style&index=0&id=7630a557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7630a557",
  null
  
)

export default component.exports